export enum EProfilyTyp {
    EMITENT = 'EMITENT',
    LEI = 'LEI',
    STATNISPRAVA = 'STATNISPRAVA',
    AKCIONAR = 'AKCIONAR',
    CDCPSRD = 'CDCPSRD',
    ADMEMIT = 'ADMEMIT',
    UCASTNIK = 'UCASTNIK',
    SPRAVCEUCTU = 'SPRAVCEUCTU',
    SPRAVCELEI = 'SPRAVCELEI',
    ADMINISTRATOR = 'ADMINISTRATOR',
    TEXTY = 'TEXTY',
    ADMINVFO = 'ADMINVFO',
    PODLT = 'PODLT',
    JINAOSOBA = 'JINAOSOBA'
}
